import { EntityBase } from "projects/sepidz-web-framework/src/lib/models/entity-base.model";
import { Lookup } from "../../../../../projects/sepidz-web-framework/src/lib/models";
import { Party } from "./party.model";
import { Zone, ZoneBranch } from "./zone.model";
import { CustomerCategory } from "./customer-categories.model";

export class Customer extends EntityBase {
  public PartyId: number;
  public FirstName: string;
  public LastName: string;
  public DisplayName: string;
  public NationalId: string;
  public NationalCode: string;
  public Description: string;
  public Number?: number;
  public Title: string;
  public IsActive: boolean;
  public ShamsiVoucherDate: string;
  public DeactivationReason: string;
  public GenderId: number;
  public Party: Party;
  public GenderTitle: string;
  public HasCredit: boolean;
  public CreditLimit?: number;
  public CreditControlTypeId?: number;
  public CreditControlTypeCode?: number;
  public CreditControlTypeTitle: string;
  public AutomaticDebtor: boolean;
  public CategoryId: number;
  public PercentDiscount?: number;
  public CategoryTitle: string;
  public DebitRate: number;
  public CountBuy: number;
  public MaximumBuy: number;
  public MinimumBuy: number;
  public TotalBuy: number;
  public LastBuy: number;
  public LastBuyDate?: string;
  public NumberTypeId?: number;
  public NumberTypeTitle: string;
  public PhoneNumber: string;
  public ZoneId?: number;
  public ZoneTitle: string;
  public Address: string;
  public ShippingCost?: number;
  public CourierShippingCost?: number;
  public BuyCount?: number;
  public MinutesToDelivery: number;
  public MaxBuy: number;
  public MintBuy: number;
  public DefaultBranches: number;
  public FailurePaymentLink: boolean;
  public EconomicCode?: number;
  public PostalCode?: number;
  public RegistrationNumber: string;
  public RegistrationDate: Date;
  public Addresses: CustomerAddress[];
  public Numbers: CustomerContactNumber[];
  public Occasions: CustomerOccasion[];
  public SelectedAddressId: number;
  public SelectedPhoneId: number;
  public DetailLedgerId?: number;
  public DetailLedgerCode?: number;
  public CreatedUserTitle: string;
  public ModifiedUserTitle: string;
  public RemainedOrganizationDiscount: number;
  public Category: CustomerCategory;
  constructor() {
    super();
    this.EconomicCode = 0;
    this.PostalCode = 0;
    this.RegistrationDate = new Date();
    this.Party = new Party();
    this.RemainedOrganizationDiscount = null;
  }
}

export class CustomerGridViewModel {
  public Id: number;
  public Description: string;
  public Number?: number;
  public PhoneNumber: string;
  public Address: string;
  public ShippingCost?: number;
  public SelectedAddressId: number;
  public SelectedPhoneId: number;
  public FirstName: string;
  public LastName: string;
  public Party: Party;

  constructor() {
    this.Id = null;
    this.Address = null;
    this.Description = null;
    this.Number = null;
    this.PhoneNumber = null;
    this.ShippingCost = null;
    this.FirstName = null;
    this.LastName = null;
  }
}
export class CustomerDetailInfoViewModel {
  public Id: number;
  public DisplayName: string;
  public Number?: number;
  public HasCredit: boolean;
  public CreditLimit?: number;
  public AutomaticDebtor: boolean;
  public PersonalityKindCode?: number;
  public GenderTitle: string;
  public CreditControlTypeCode?: number;
  public DebitRate: number;
  public LastBuy: number;
  public CountBuy: number;
  public MaximumBuy: number;
  public MinimumBuy: number;
  public TotalBuy: number;
  public Addresses: CustomerAddress[];
  public Numbers: CustomerContactNumber[];
  public Occasions: CustomerOccasion[];
  public NumberTypeId?: number;
  public PhoneNumber: string;
  public Address: string;
  public ShippingCost?: number;
  public CourierShippingCost?: number;
  public Credit?: number;
  public LastBuyDate?: string;
  public SelectedAddressId?: number;
  public SelectedPhoneId: number;
  public MinutesToDelivery?: number;
  public IsActive: boolean;
  public CategoryId: number;
  public DeactivationReason: string;
  public RemainedOrganizationDiscount?: number;
  public OrganizationalDiscountValue?: number;
  public FailurePaymentLink: boolean;
  public Category: CustomerCategory;
  constructor() {
    this.Addresses = [];
  }
}

export class CustomerAddress extends EntityBase {
  public CustomerId: number;
  public ZoneId: number;
  public ShippingCost?: number;
  public CourierShippingCost?: number;
  public IsDefault: boolean;
  public Address: string;
  public Zone: Zone;
  public Order: number;
  public DefaultBranchId: number;
  public DefaultBranchTitle: string;
  public Latitude: number;
  public Longitude: number;
}
export class CustomerOccasion extends EntityBase {
  public BranchId: number;
  public CustomerId: number;
  public Day: number;
  public Month: number;
  public TemplateId: number;
}
export class MaxCodeViewModel {
  public HaspreFix: Boolean;
  public MaxCode: number;
}
export class CustomerContactNumber extends EntityBase {
  public Number: string;
  public NumberTypeId: number;
  public NumberTypeTitle: string;
  public NumberTypeCode?: number;
  public IsDefault: boolean;
  public CustomerId: number;
  public Order: number;
}
export class ZoneLookup extends Lookup {
  public CustomerId: number;
  public ZoneId: number;
  public ShippingCost?: number;
  public CourierShippingCost?: number;
  public IsDefault: boolean;
  public Address: string;
  public Zone: Zone;
  public Order: number;
  public DefaultId: number;
  public DefaultTitle: number;
  public Branches: ZoneBranch[];
}
export enum PersonalityKindEnum {
  Realperson = 1,
  Legalperson = 2,
}
export enum GenderEnum {
  Male = 1,
  Female = 2,
}

export enum CreditControlType {
  Warning = 1,
  Inhibit = 2,
}
